import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'transfer-vertical',
  'IconTransferVertical',
  [
    ['path', { d: 'M10 4v16l-6 -5.5', key: 'svg-0' }],
    ['path', { d: 'M14 20v-16l6 5.5', key: 'svg-1' }],
  ],
);
